import { render, staticRenderFns } from "./UserPersonal.vue?vue&type=template&id=1e366ba3&scoped=true&"
import script from "./UserPersonal.vue?vue&type=script&lang=js&"
export * from "./UserPersonal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e366ba3",
  null
  
)

export default component.exports